import { IsString, IsNumber, IsBoolean } from 'class-validator';
import { EntityVm } from 'api/core/entity.vm';

export class ProductVm extends EntityVm {
  @IsString()
  measureUnitId: string;

  @IsString()
  measureUnitAcronym: string;

  @IsString()
  defaultSupplierId: string;

  @IsString()
  name: string;

  @IsString()
  sku: string;

  @IsString()
  externalId: string;

  @IsString()
  optionalCode: string;

  @IsString()
  description: string;

  @IsNumber()
  packageSize: number;

  @IsBoolean()
  isContainer: boolean;

  @IsBoolean()
  usesPackage: boolean;

  @IsBoolean()
  usesBatch: boolean;

  @IsBoolean()
  usesExpiryDate: boolean;

  @IsBoolean()
  usesSerialNumber: boolean;

  @IsBoolean()
  usesContainer: boolean;

  @IsBoolean()
  usesIntegerQuantity: boolean;

  @IsBoolean()
  usesAtomicUnits: boolean;

  @IsBoolean()
  needsPreparation: boolean;
}
